export default "__VITE_ASSET__DBPWyjOA__"